<div class="user-context-switcher-comp">
  <form [formGroup]="loginOverlayForm" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px"
    class="form-height login-form">
    <p class="text-large" id="edit-text">
 {{(pageContent | contentFilter: LABELS.EDIT_SELECTION_LABEL) || 'Edit your selection'}}    </p>
    @if(roleOptions.length){
    <div fxLayout="column" fxLayoutAlign="center center" class="role-sect"
      [ngClass]="(roleOptions?.length > 1 || roleOptions[0]?.value)? '': 'hide-control'">
      <nuc-select displayClass="role-dropdown" [options]="roleOptions" id="role-select"
[label]="(pageContent | contentFilter: LABELS.EDIT_ROLE_LABEL) || 'Choose a Role'"        [formControl]="getFormControl('role')"></nuc-select>
    </div>
    }


    <div class="switcher subtoolbar-switcher">
      <nuc-button [text]="(pageContent | contentFilter: LABELS.CANCEL_BUTTON_TEXT) || 'Cancel'"
        styleClass="secondaryBtn" (click)="close(false)" class="cancelButton" onKeyDown></nuc-button>
        <nuc-button [text]="(pageContent | contentFilter: LABELS.PROCEED_BUTTON) || 'Proceed'" styleClass="primaryBtn"
        [disabled]="!canSubmit()" (click)="close(true)" class="proceedButton" onKeyDown></nuc-button>
    </div>
  </form>
</div>